export const loadClient = async (clientName: string) => {
  if (clientName === 'AuthClient') {
    const { default: AuthClient } = await import('@skyscanner/auth-client');
    return AuthClient;
  }
  throw new Error(`Unknown client name: ${clientName}`);
};
